<template>
  <div v-if="pageConfig" class="trial-page">
    <Forbid v-if="!hasPermission"></Forbid>
    <TemplatePreset
      v-else
      :agreementTip="agreementTip"
      :agreementType="pageConfig.agreement_type"
      :agreementTitles="agreements"
      :defaultSelectStatus="defaultSelectStatus"
      :stopScroll="isFinish"
      :isShowAgreementSelect="!isApplySuccess"
      :isBlueStyle="true"
      @initAgreements="handleInitAgreements"
      @agree-change="
        (agree) => {
          isAgree = agree;
        }
      "
    >
      <template v-slot:main class="trial">
        <!-- <ProxyImg v-if="pageConfig.header" :img="pageConfig.header"></ProxyImg> -->
        <!-- 传播模型报名页 用户数据信息 -->
        <ProxyImg :img="pageConfig.content[0].data[0]">
          <UserInfo @getUserInfo="getUserInfo" />
        </ProxyImg>
        <div
          v-for="(item, index) in pageConfig.content"
          :id="index === 1 && hasMobileModule ? 'mobile-wrapper' : ''"
          :key="index"
          class="comp-wrapper"
        >
          <valid-phone
            v-if="index === 1"
            :isAgree="isAgree"
            :validPhone="pageConfig.mobile"
            :messageType="pageConfig.business_type"
            :btnColor="pageConfig.mobile_button_color"
            :bg="item.data[1]"
            :btnText="validPhoneText"
            @apply="handleApply"
            @valid-success="handleValidSucces"
            @get-code="handleGetCode"
          />

          <!-- 第二张图[]的第二项是手机号模块背景，只展示item.data[0] -->
          <component
            :is="compMap[item.type]"
            v-if="index !== 0"
            ref="resList"
            :data="index === 1 ? [item.data[0]] : item.data"
            :productionId="productionId"
            @track-btn-click="$emit('track-btn-click', arguments[0])"
          ></component>
        </div>
      </template>
      <div v-show="!isShowMobileValid" slot="bottom" class="bottom-wrapper">
        <component
          :is="currentBottomComp"
          ref="bottom"
          :config="bottomConfig.config"
          :type="bottomConfig.type"
          :isAgree="isAgree"
          :isFinish="isFinish"
          :bgColor="pageConfig.button_color"
          @apply="handleApply"
          @go-url="handleGoUrl"
          @success-modal="handleOpenModal"
        ></component>
      </div>

      <!-- 支付方式模块 -->
      <template slot="container-absolute-item">
        <ChannelSwitch
          v-if="
            !pageConfig.payment_check &&
            canApply &&
            !isShowMobileValid &&
            !isFreePrice
          "
          :canSelect="supportType.length > 1"
          :config="payConfig"
          class="switch"
          @change="isShowPayChannel = true"
        ></ChannelSwitch>
        <ModalChannelSelect
          v-if="
            !pageConfig.payment_check &&
            canApply &&
            !isShowMobileValid &&
            !isFreePrice
          "
          :toggle="isShowPayChannel"
          :supportType="supportType"
          :useAbsolutePosition="true"
          :defaultType="defaultPayType"
          :huabeiList="huabeiList"
          :huabeiTotalAmount="huabeiTotalAmount"
          @change="onChangeChannel"
          @close="isShowPayChannel = false"
        ></ModalChannelSelect>
      </template>

      <template slot="fix-items">
        <PopupTipSuccess
          :textConfig="popupConfig"
          :isShow="isShowSuccessPopup"
          :closable="popupConfig.closable"
          @close="isShowSuccessPopup = false"
        ></PopupTipSuccess>
      </template>
    </TemplatePreset>
    <!-- <component
      :is="
        questionCompMap[pageConfig.survey_type || 'idp_class'] ||
        questionCompMap.idp_class
      "
      :isShow="isShowQuestionnaire"
      :surveyCode="questionSurveyCode"
      @refresh="onQuestionnaireFinish"
    /> -->
    <!-- <QuestionnaireNormal
      @refresh="onQuestionnaireFinish"
      :isShow="isShowQuestionnaire"
      :surveyCode="questionSurveyCode"
    /> -->
    <!-- <QuestionnairePy
      @refresh="onQuestionnaireFinish"
      :isShow="isShowQuestionnaire"
      :surveyCode="questionSurveyCode"
    /> -->
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import EnrollmentMixin from '../mixins/EnrollmentMixin';
import Closure2TrackerMixin from '../mixins/Closure2TrackerMixin';
import TemplatePreset from '@/modules/common/TemplatePreset.vue';
import StaticContent from '../../flashcode/components/StaticContent.vue';
import BottomApply from './components/Apply.vue';
import BottomProcess from '../../flashcode/components/Process.vue';
import { Route } from 'vue-router';
import PopupTipSuccess from '@/modules/common/PopupTipSuccess';
import ProxyImg from '@/modules/common/ProxyImg';
import Forbid from '../Forbid.vue';
import ScrollTracker from '@/lib/ScrollTracker';
import { promiseLock } from '@/lib/decorates';
import { handlePayment } from '@/modules/common/helps';
import { PayChannel } from '@/lib/pingpp';
import {
  IPayType,
  ModalChannelSelect,
  ChannelSwitch,
  allChannels,
  PayTypes,
} from '@/modules/common/MutiPayChannel';
import {
  IAgreement,
  IBottom,
  IPageConfig,
  IUserData,
  BottomType,
  IUserInfo,
} from '../types';
import toast, { ToastType } from '@/basic/components/Toast';
import validPhone from '../components/ValidPhone.vue';
import UserInfo from './components/UserInfo.vue';
interface IModelPageTrack {
  page_name: string;
  plan_id: string;
  plan_name: string;
  tracking_scene: string;
  url: string;
}
@Component({
  components: {
    TemplatePreset,
    StaticContent,
    BottomApply,
    PopupTipSuccess,
    ProxyImg,
    Forbid,
    ChannelSwitch,
    ModalChannelSelect,
    validPhone,
    UserInfo,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    window.Al.start();
    window.np.start();
    console.log(to);
    Promise.all([
      window.apis.getSingleInfo({
        ...to.params,
        ...to.query,
        production_id: to.params.id,
      }),
      window.apis.getSingleUser({
        ...to.params,
        ...to.query,
        production_id: to.params.id,
      }),
    ])
      .then(([productionRes, userRes]) => {
        if (userRes.data && userRes.data.success_url) {
          next(() => {
            window.location.replace(userRes.data.success_url);
          });
        } else {
          next((vm: CommunicationModel) => {
            vm.handleSetPageTitle(productionRes.data.index_title);
            vm.initResource(productionRes.data, userRes.data);

            window.Al.done();
            window.np.done();
          });
        }
      })
      .catch((e) => {
        console.log('init', e);
      });
  },
})
export default class CommunicationModel extends Mixins(
  EnrollmentMixin,
  Closure2TrackerMixin
) {
  $refs!: {
    bottom: {
      handleUserAction: Function;
    };
    content: StaticContent;
    resList: any;
  };
  pageConfig: IPageConfig | null = null;
  isAgree = true;
  modelPageTrackInfo: IModelPageTrack | null = null;
  productionId = 0;
  bottomConfig: IBottom = {
    type: BottomType.APPLY,
    config: null,
  };
  isShowSuccessPopup = false;
  popupConfig: any = {};
  isForbidScroll = false;
  hasPermission = true;

  isShowPayChannel = false;
  payConfig: IPayType = allChannels['wechat'];

  supportType: PayTypes[] = [];
  defaultPayType: PayTypes = PayTypes.wechat;
  agreements: string[] = [];

  get currentBottomComp() {
    return this.bottomConfig.type === BottomType.APPLY
      ? BottomApply
      : BottomProcess;
  }
  get isFinish() {
    return this.bottomConfig.type === BottomType.FINISH;
  }
  get isApplySuccess() {
    return this.bottomConfig.type !== BottomType.APPLY && !this.isFinish;
  }
  get canApply() {
    return this.bottomConfig.type === BottomType.APPLY;
  }
  get agreementTip() {
    return `请阅读并勾选${this.agreements.join(' ')}`;
  }
  get defaultSelectStatus() {
    if (!this.canApply) {
      return true;
    }

    return this.pageConfig?.agreement_check || false;
  }

  mounted() {
    this.addEventListenerPopstate();
    setTimeout(() => {
      const ele = document.getElementById('t-scroll-container');
      if (ele) {
        new ScrollTracker((s, e) => {
          this.__modelPageTrackScrollPageview();
        }, ele).register();
      }
    });
  }

  getUserInfo({ activity_class_id, InviterUserId }: IUserInfo) {
    this.userInfo = {
      activity_class_id: activity_class_id,
      InviterUserId: InviterUserId,
    };
  }

  addEventListenerPopstate() {
    if (window.history && window.history.pushState) {
      window.history.pushState('forward', '', location.href);
      window.addEventListener('popstate', this.backChange, false);
    }
  }

  backChange() {
    // @ts-ignore
    window.history.forward(1);
  }

  initResource(data: IPageConfig, userData: IUserData) {
    if (data.redirect_url) {
      window.location.replace(data.redirect_url);
      return;
    }

    this.hasPermission = data.permission;
    this.productionId = data.production_id;

    // 初始化分享信息
    if (data && data.share) {
      const share = data.share;
      this.$initShare(() => {
        window.wx.ready(() => {
          window.wx.onMenuShareTimeline(share.timeline);
          window.wx.onMenuShareAppMessage(share.app_message);
        });
      });
    }

    // 无资格，展示无资格页面
    if (!this.hasPermission) {
      this.pageConfig = data;
      return;
    }

    this.initUser(userData); // Todo
    const config = userData.bottom.config;
    const payment_configs = data.payment_configs;
    if (payment_configs) {
      this.defaultPayType =
        data.default_payment || payment_configs[0] || PayTypes.wechat;
      this.payConfig = allChannels[this.defaultPayType];
      this.supportType = payment_configs;
    }

    this.pageConfig = data;
    this.initModePageTrackData();
    this.handleModelPageViewTrack();
  }
  initModePageTrackData() {
    this.modelPageTrackInfo = {
      tracking_scene: '传播模型-排行榜',
      url: window.location.href,
      page_name: '专属邀请报名页',
      plan_id: `${this.$route.query.activity_class_id}`,
      plan_name: '',
    };
  }
  initUser(data: IUserData) {
    this.couponId = data.coupon_id;
    this.bottomConfig = data.bottom;

    if (!this.canApply) {
      this.handleRecordCoupon();
    }

    this.$nextTick(() => {
      if (this.bottomConfig.config!.show) {
        this.$refs.bottom.handleUserAction();
      }
    });
  }

  handleGoUrl(config: { url: string; button: string }) {
    this.__modelPageButtonClickTrack();
    if (config.url) {
      setTimeout(() => {
        window.location.href = config.url;
      }, 300);
    }
  }
  handleOpenModal(config: { modal: any }) {
    this.popupConfig = config.modal;
    this.isShowSuccessPopup = true;
  }

  freshBottomConfig() {
    return window.apis
      .getSingleUser({
        ...this.$route.params,
        mode: this.$route.query.mode,
        production_id: this.$route.params.id,
      })
      .then((res: any) => {
        if (res.data && res.data.success_url) {
          window.location.replace(res.data.success_url);
        } else {
          this.initUser(res.data);
        }
      })
      .catch((e: any) => {
        console.log('freshBottomConfig', e);
      });
  }

  handleInitAgreements(res: IAgreement[]) {
    if (res.length) {
      this.agreements = res.map((agreement: IAgreement) => agreement.title);
    }
  }

  checkUserId() {
    const { InviterUserId } = this.userInfo;
    return InviterUserId >= 0;
  }

  @promiseLock
  handleApply() {
    if (!this.checkMobile()) {
      return;
    }

    if (!this.checkUserId())
      return toast({ type: ToastType.error_network, value: '网络异常' });

    this.__modelPageButtonClickTrack(true);

    if (!this.isFreePrice && this.pageConfig?.payment_check) {
      this.handleToPayPlatform();

      return;
    }

    const payMethod = this.isFreePrice ? this.handleFreePayment : handlePayment;

    // 分期参数
    const fenqiPayParams =
      this.payConfig.channel === PayChannel.huabei
        ? { hb_fq_num: this.payTerm }
        : {};

    // 传播模型报名页参数
    const communicationModelParams = this.handleCommunicationModelPramas();

    // 如果链接上带有c_id（有优惠券）,向后端发起记录请求
    return payMethod(
      this.productionId,
      {
        channel: this.payConfig.channel,
        mobile: this.pageConfig?.mobile,
      },
      this.priceCountDown > 0
        ? {
            ...this.$route.query,
            use_coupon: false,
            ...fenqiPayParams,
            ...communicationModelParams,
          }
        : {
            ...this.$route.query,
            ...fenqiPayParams,
            ...communicationModelParams,
          }
    )
      .then(() => {
        this.isShowMobileValid = false;
        this.eleObserver && this.eleObserver.unobserve();

        return this.freshBottomConfig();
      })
      .catch((e: any) => {
        console.log('pay', e);
      });
  }
  destroyed() {
    document.removeEventListener('popstate', this.backChange);
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';
@import '@/style/animate.scss';
.switch {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.trial-page {
  width: 100%;
  height: 100%;
}
.comp-wrapper {
  position: relative;
}

@include pulse;
.animate-pluse {
  animation-name: pulse;
  animation-duration: 700ms;
  animation-iteration-count: infinite;
}
</style>
